module.exports = __webpack_public_path__ + "static/media/1.70a80473.jpg";